import { Grid } from "@mui/material";
import React from "react";
import { FlexCenter } from "../../../constant/CustomeStyle";

const WarehouseTypeList = () => {
  return (
    <div>
      <FlexCenter>
        <TopTitle />
      </FlexCenter>

      <FlexCenter style={{ width: 702, marginTop: 30 }}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {Array.from(Array(15)).map((item, index) => (
            <SingleBox item={item} key={index} nom={index} />
          ))}
        </Grid>
      </FlexCenter>
    </div>
  );
};

const SingleBox = ({ item, nom }) => (
  <FlexCenter
    style={{
      background: "#FFF",
      width: 130,
      height: 69,
      marginBottom: 15,
      cursor: "pointer",
      borderRadius: 4,
    }}
  >
    <div
      style={{
        color: "#424242",
        fontSize: 14,
        fontWeight: "500",
        fontFamily: `Poppins, sans-serif`,
        padding: "0 5px",
      }}
    >
      Warehouse Type {nom}
    </div>
  </FlexCenter>
);

const TopTitle = () => (
  <FlexCenter
    style={{
      width: 702,
      height: 55.15,
      color: "#FFF",
      background: "#0E5A41",
      fontSize: 20,
      fontWeight: "600",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    Warehouse Type List
  </FlexCenter>
);

export default WarehouseTypeList;
